import { SHOW_ASK_QINGDAO_SECTION } from '@/config/newIndexDataSource.js';

export const NAV_LIST_ROUTES = {
  '#home': '/newIndex',
  '#latest-news': '/news',
  '#qingdao-world': '/active_list',
  '#int-communication': '/international',
  '#photo-depot': '/topic_pic',
  '#visual-qingdao': '/topic_video',
  '#qd-release': '/publish',
  '#vr-hall': '/fvr',
  '#qd-service': '/newIndex',
};

export const LIST_ROUTE_NAV_KEY = {
  '/news': '#latest-news',
  '/active_list': '#qingdao-world',
  '/international': '#int-communication',
  '/topic_pic': '#photo-depot',
  '/topic_video': '#visual-qingdao',
  '/publish': '#qd-release',
  '/fvr': '#vr-hall',
};

const SUB_ROUTE_STACKED = {
  layout: 'stacked',
  theme: 'solid',
  showHeaderSearch: false,
};

const SUB_ROUTE_HERO = {
  layout: 'hero-overlay',
  theme: 'solid',
  showHeaderSearch: false,
};

const HERO_OVERLAY_PATHS = [
  '/active/',
  '/activity/',
  '/gallery/',
];

export const SUB_ROUTE_RULES = [
  { test: (p) => p.startsWith('/news/'), nav: '#latest-news', config: SUB_ROUTE_STACKED },
  {
    test: (p) => p.startsWith('/active/')
      || p.startsWith('/activity/')
      || p.startsWith('/collect/')
      || p.startsWith('/activity-news/'),
    nav: '#qingdao-world',
    config: (p) => (HERO_OVERLAY_PATHS.some((prefix) => p.startsWith(prefix)) ? SUB_ROUTE_HERO : SUB_ROUTE_STACKED),
  },
  { test: (p) => p.startsWith('/intl/'), nav: '#int-communication', config: SUB_ROUTE_STACKED },
  { test: (p) => p.startsWith('/release/'), nav: '#qd-release', config: SUB_ROUTE_STACKED },
  {
    test: (p) => p.startsWith('/gallery/')
      || p.startsWith('/photos/')
      || p.startsWith('/photo/')
      || p.startsWith('/weekly-pick'),
    nav: '#photo-depot',
    config: (p) => (p.startsWith('/gallery/') ? SUB_ROUTE_HERO : SUB_ROUTE_STACKED),
  },
  { test: (p) => p.startsWith('/video/'), nav: '#visual-qingdao', config: SUB_ROUTE_STACKED },
];

const BASE_NAV_ITEMS = [
  { labelKey: 'newIndex.nav.home', href: '#home' },
  { labelKey: 'newIndex.nav.trendingNews', href: '#latest-news' },
  { labelKey: 'newIndex.nav.vibrantCity', href: '#qingdao-world' },
  { labelKey: 'newIndex.nav.globalOutreach', href: '#int-communication' },
  { labelKey: 'newIndex.nav.photoGallery', href: '#photo-depot' },
  { labelKey: 'newIndex.nav.visualQingdao', href: '#visual-qingdao' },
  { labelKey: 'newIndex.nav.qdRelease', href: '#qd-release' },
  { labelKey: 'newIndex.categories.vr', href: '#vr-hall' },
  { labelKey: 'newIndex.nav.servicesHub', href: '#qd-service' },
];

export function getNavItems() {
  if (SHOW_ASK_QINGDAO_SECTION) {
    return BASE_NAV_ITEMS;
  }
  return BASE_NAV_ITEMS.filter((item) => item.href !== '#qd-service');
}

export const HOME_SECTION_IDS = SHOW_ASK_QINGDAO_SECTION
  ? ['#home', '#latest-news', '#qingdao-world', '#int-communication', '#photo-depot', '#visual-qingdao', '#qd-release', '#vr-hall', '#qd-service']
  : ['#home', '#latest-news', '#qingdao-world', '#int-communication', '#photo-depot', '#visual-qingdao', '#qd-release', '#vr-hall'];

export const DEFAULT_SITE_HEADER = {
  layout: 'stacked',
  theme: 'solid',
  showHeaderSearch: true,
  showHeaderLang: true,
};

export const SITE_HEADER_CONFIG = {
  '/news': {
    layout: 'hero-overlay',
    theme: 'solid',
    showHeaderSearch: false,
  },
  '/active_list': {
    layout: 'hero-overlay',
    theme: 'solid',
    showHeaderSearch: false,
  },
  '/international': {
    layout: 'hero-overlay',
    theme: 'solid',
    showHeaderSearch: false,
  },
  '/topic_pic': {
    layout: 'hero-overlay',
    theme: 'solid',
    showHeaderSearch: false,
  },
  '/topic_video': {
    layout: 'hero-overlay',
    theme: 'solid',
    showHeaderSearch: false,
  },
  '/publish': {
    layout: 'hero-overlay',
    theme: 'solid',
    showHeaderSearch: false,
  },
  '/fvr': {
    layout: 'hero-overlay',
    theme: 'solid',
    showHeaderSearch: false,
  },
};

function matchSubRouteRule(path) {
  return SUB_ROUTE_RULES.find((rule) => rule.test(path));
}

function resolveSubRouteConfig(path, rule) {
  const config = typeof rule.config === 'function' ? rule.config(path) : rule.config;
  return { ...DEFAULT_SITE_HEADER, ...config };
}

export function resolveSiteHeaderConfig(path) {
  if (!path) return { ...DEFAULT_SITE_HEADER };
  if (path.startsWith('/my/') || path === '/my') {
    return {
      ...DEFAULT_SITE_HEADER,
      showHeaderSearch: false,
      showHeaderLang: false,
    };
  }
  if (SITE_HEADER_CONFIG[path]) {
    return { ...DEFAULT_SITE_HEADER, ...SITE_HEADER_CONFIG[path] };
  }

  const subRule = matchSubRouteRule(path);
  if (subRule) {
    return resolveSubRouteConfig(path, subRule);
  }

  return { ...DEFAULT_SITE_HEADER };
}

export function resolveSiteActiveNav(path) {
  if (!path || path.startsWith('/my/') || path === '/my') {
    return '';
  }
  if (LIST_ROUTE_NAV_KEY[path]) {
    return LIST_ROUTE_NAV_KEY[path];
  }

  const subRule = matchSubRouteRule(path);
  return subRule?.nav || '';
}

export function resolveNavRoute(href) {
  return NAV_LIST_ROUTES[href] || '/newIndex';
}
